import AntDIcon from 'antd/lib/icon'
import React from 'react'
import styled from 'styled-components'

const SALES_ADVISOR_COLOURS = {
  body: '#0ea5e9',
  inverse: '#FFFFFF',
  onBrand: '#000000',
}

/**
 * Sales Advisor mark — a spark for supplier-facing AI insight.
 * Sibling to OllieIcon: same size/variant API, distinct sky-blue identity.
 */
const Icon = ({ size = 24, variant = 'default' }) => {
  const fill =
    variant === 'inverse'
      ? SALES_ADVISOR_COLOURS.inverse
      : variant === 'onBrand'
      ? SALES_ADVISOR_COLOURS.onBrand
      : SALES_ADVISOR_COLOURS.body

  const SVG = () => (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      role='img'
    >
      <path
        fill={fill}
        d='M12 2.2l1.55 6.05L19.7 10l-6.15 1.75L12 17.8l-1.55-6.05L4.3 10l6.15-1.75L12 2.2z'
      />
      <path
        fill={fill}
        d='M18.35 3.4l.72 2.18 2.18.72-2.18.72-.72 2.18-.72-2.18-2.18-.72 2.18-.72.72-2.18z'
      />
      <path
        fill={fill}
        opacity='0.85'
        d='M6.2 15.15l.58 1.72 1.72.58-1.72.58L6.2 19.75l-.58-1.72-1.72-.58 1.72-.58.58-1.72z'
      />
    </svg>
  )

  return <AntDIcon component={SVG} />
}

const MarkBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  border-radius: 999px;
  background: linear-gradient(135deg, #38bdf8 0%, #0284c7 55%, #0369a1 100%);
  box-shadow: 0 6px 14px rgba(14, 165, 233, 0.32);
`

const SalesAdvisorMark = ({ size = 28, iconSize }) => (
  <MarkBadge $size={size} aria-hidden='true'>
    <Icon size={iconSize || Math.round(size * 0.58)} variant='inverse' />
  </MarkBadge>
)

export default Icon
export { SalesAdvisorMark, SALES_ADVISOR_COLOURS }
